import React, { Fragment, useRef, useState, useEffect } from 'react'
import PopUp from '../Common/PopUp';
import Filter from '../Common/Filter';
import Table from '../Common/Table';
import { showToast } from '../Common/Messages';
import { useSelector } from 'react-redux';
import { dateFormat } from '../libs/Util';

export function usePrevState(state) {
    const ref = useRef(state);
    useEffect(() => {
        ref.current = state;
    }, [state]);
    return ref.current;
}

const UserAccountManagement = () => {
    const loginInfo = useSelector(state => state.login);
    const loginUserId = loginInfo.userId;

    const [veiwList, setVeiwList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [listTitle, setListTitle] = useState('');
    const [popupContent, setPopupContent] = useState(null);
    const [displayCompanyList, setDisplayCompanyList] = useState([]);
    const [selectedCompanyList, setSelectedCompanyList] = useState([]);
    const authGradeList = ["", "Staff", "Manager"];
    let selectedAuthGrade = '', selectedRecvMail = '0';
    const [groupList, setGroupList] = useState([]);
    const [groupMemberList, setGroupMemberList] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [newGroup, setNewGroup] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editName, setEditName] = useState('');
    const [showContextMenu, setShowContextMenu] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [checkedItems, setCheckedItems] = useState(new Set());
    const [isCheckedAll, setIsCheckedAll] = useState(false);

    useEffect(() => {
        fetch('api/Manager/GetUserAuthGroup', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
            .then((data) => {
                setGroupList(data.table);
                setGroupMemberList(data.table1);
            });
        const handleClickOutside = (e) => {
            if (!e.target.closest('.context-menu') && !e.target.classList.contains('kebab-24')) {
                setShowContextMenu(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (userList.length === 0) {
            fetch('api/User/GetUserInfo', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then((response) => response.json())
                .then((data) => {
                    setUserList(data.table);
                });
        }
    }, [userList, displayCompanyList, selectedCompanyList]);

    useEffect(() => {
        if (selectedIndex !== -1 && userList.length > 0) {
            const filteredUsers = getFilteredUserList(true);
            setVeiwList(filteredUsers);
            setFilteredUsers(filteredUsers);
        } else {
            setVeiwList(userList);
            setFilteredUsers(userList);
        }
    }, [selectedIndex, userList, groupMemberList]);

    useEffect(() => {
        const groupName = groupList.find(group => group.groupSeq === selectedIndex)?.groupName || '전체';
        setListTitle(filteredUsers.length > 0 ? `${groupName} (${filteredUsers.length}명)` : groupName);
    }, [filteredUsers]);

    const handleAddGroup = () => {
        if (!newGroup || newGroup.trim() === '') return;
        SaveUserAuthGroup('A', -1, newGroup);
        setNewGroup(null);
    };

    const handleDeleteGroup = (groupSeq) => {
        SaveUserAuthGroup('D', groupSeq);
        setShowContextMenu(null);
    };

    const handleEditGroup = (index) => {
        setEditingIndex(index);
        setEditName(groupList[index].groupName);
        setShowContextMenu(null);
    };

    const handleSaveEdit = (index) => {
        if (!editName || editName.trim() === '') return;
        const groupSeq = groupList[index].groupSeq;
        SaveUserAuthGroup('U', groupSeq, editName);
        setEditingIndex(null);
    };

    const handleSelectGroup = (index) => {
        setIsCheckedAll(false);
        setCheckedItems(new Set());
        setSelectedIndex(index);
    };

    const handleChange = (e) => {
        if (e.target.id === 'authGrade') {
            selectedAuthGrade = (e.target.value === '없음' ? '' : e.target.value);
        } else if (e.target.id === 'recvMail') {
            selectedRecvMail = e.target.value;
        }
    }

    const SaveUserAuthGroup = (workingTag, groupSeq = -1, groupName = '') => {
        fetch('api/Manager/SaveUserAuthGroup', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                WorkingTag: workingTag,
                DevUserId: loginUserId,
                GroupSeq: groupSeq,
                GroupName: groupName
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.table) {
                    setGroupList(data.table);
                }
            })
            .catch(error => console.error('Error saveUserAuthGroup:', error));
    };

    const getSendOtpName = (value) => {
        let Text = '사용안함';
        if (value === 1) {
            Text = '메일';
        }
        if (value === 2) {
            Text = '카카오톡';
        }
        if (value === 3) {
            Text = 'SMS';
        }
        return Text;
    }
    const btnOnPopup = (e, item, index) => {
        setPopupContent(item !== null && item !== undefined
            ? renderMoreMenu(item, index) : null);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseDown = (event) => {
        setPosition({ x: event.clientX, y: event.clientY });
    };

    const renderMoreMenu = (item, index) => {
        return (
            <div className="layer-list admin-more-menu" style={{ top: position.y + 'px', left: position.x + 'px' }}>
                <div className="box">
                    <ul>
                        <li><a onClick={e => renderSelectedUserInfo(item, index)}>사용자 정보</a></li>
                        <li><a onClick={e => setTempPassword(item)}>임시비밀번호 발급</a></li>
                        <li><a onClick={e => resetLoginFailCnt(item, index)}>로그인 실패횟수 초기화</a></li>
                    </ul>
                </div>
            </div>
        );
    }

    const renderSelectedUserInfo = (item, index) => {
        let pwdChgDate = '';

        if (item !== null && item !== undefined && item.pwdChgDate !== null && item.pwdChgDate !== undefined) {
            if (item.pwdChgDate.trim() !== '') {
                pwdChgDate = item.pwdChgDate.substr(0, 4) + '.' + item.pwdChgDate.substr(4, 2) + '.' + item.pwdChgDate.substr(6, 2);
            }
        }
        setPopupContent(item !== null && item !== undefined
            ? <div className="msg-popup admin-user-info">
                <div className="box w-480">
                    <div className="title-wrap">
                        <p className="modal-title">사용자 정보</p>
                        <button className="btn-close" onClick={e => btnOnPopup(e, null, null)}><i className="icoKdc32 close"></i></button>
                    </div>
                    <form className="form-wrap">
                        <div className="user-info-list">
                            <dl className="" id="kindText">
                                <dt>이름</dt>
                                <dd>{item.devUserName}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>이메일 아이디</dt>
                                <dd>{item.devUserID}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>소속</dt>
                                <dd>{item.getCompanyName}</dd>
                            </dl>
                            {item.deptName !== null && item.deptName !== '' ?
                                <dl className="">
                                    <dt>부서</dt>
                                    <dd>{item.deptName}</dd>
                                </dl> : null}
                            {item.getKindName !== null && item.getKindName !== '' ?
                                <dl className="">
                                    <dt>직무</dt>
                                    <dd>{item.getKindName}</dd>
                                </dl> : null}

                            <dl className="" id="">
                                <dt>2차인증</dt>
                                <dd>{getSendOtpName(item.sendOtpType)}</dd>
                            </dl>

                            <dl className="" id="">
                                <dt>비밀번호 변경일</dt>
                                <dd>{pwdChgDate}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>로그인 실패횟수</dt>
                                <dd>{item.loginFailCnt !== null ? item.loginFailCnt + "회" : "0회"}</dd>
                            </dl>
                            <dl className="" id="">
                                <dt>마지막 로그인</dt>
                                <dd>{item.lastLoginDateTime !== null ? dateFormat(new Date(item.lastLoginDateTime)) : '미접속'}</dd>
                            </dl>

                        </div>
                    </form>
                    <div className="btn-wrap">
                        <button className="btn-primary" onClick={e => saveDevelopersCenterAdmin(item, index)}>업데이트</button>
                    </div>
                </div>
            </div> : null);
    }
    const setTempPassword = (item) => {
        if (window.confirm(item.devUserID + '에 대한 임시비밀번호 발급을 진행합니다. 계속하시겠습니까?')) {
            const userNameId = {
                userName: item.devUserName,
                userId: encodeURI(item.devUserID)
            };

            fetch('api/Login/FindPassword', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(userNameId)
            }).then(async (response) => response.json())
                .then((responseData) => {
                    if (responseData.status === "Success Finding") {
                        showToast('success', '임시 비밀번호 발급에 성공하였습니다.', 3000);
                        setPopupContent(null);
                    }
                    else if (responseData.status === "Fail Sending") {
                        showToast('danger', responseData.message, 3000);
                    }
                });
        }
    }
    const resetLoginFailCnt = (item, index) => {
        if (window.confirm(item.devUserID + '에 대한 로그인 실패횟수 초기화를 진행합니다. 계속하시겠습니까?')) {
            fetch('api/User/ResetLoginFailCnt?userId=' + item.devUserID, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(async (response) => response.json())
                .then((responseData) => {
                    if (responseData.table[0].status === 'true') {
                        showToast('success', '초기화에 성공하였습니다.', 3000);
                        let newUserList = filteredUsers;
                        newUserList[index].loginFailCnt = 0;
                        setFilteredUsers(newUserList);
                        setPopupContent(null);
                    }
                    else {
                        showToast('danger', responseData.message, 3000);
                    }
                });
        }
    }
    const saveDevelopersCenterAdmin = (item, index) => {
        fetch('api/User/SaveDevelopersCenterAdmin?userId=' + item.devUserID + '&authGrade=' + selectedAuthGrade + '&recvMail=' + selectedRecvMail, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then(async (response) => response.json())
            .then((responseData) => {
                if (responseData.table[0].status === 'true') {
                    showToast('success', '저장이 완료되었습니다.', 3000);
                    let newUserList = filteredUsers;
                    newUserList[index].authGrade = selectedAuthGrade;
                    newUserList[index].recvMail = selectedRecvMail;
                    setFilteredUsers(newUserList);
                    setPopupContent(null);
                }
                else {
                    showToast('danger', responseData.message, 3000);
                }
            });
    }
    const deleteCompany = (selectedCompanyList, companyName) => {
        let list = selectedCompanyList;
        setSelectedCompanyList(list.filter(x => x !== companyName));
    }
    const renderUserList = () => {
        let list = [];
        for (let i = 0; i < filteredUsers.length; i++) {
            let pwdChgDate = '';
            if (filteredUsers[i].pwdChgDate !== null) {
                if (filteredUsers[i].pwdChgDate.trim() !== '') {
                    pwdChgDate = filteredUsers[i].pwdChgDate.substr(0, 4) + '.' + filteredUsers[i].pwdChgDate.substr(4, 2) + '.' + filteredUsers[i].pwdChgDate.substr(6, 2);
                }
            }
            list.push(
                <tr key={i}>
                    <td onClick={(e) => checkHandler(i)}><div className="list-checkbox"><input type="checkbox" id={"chk" + i} value={i} checked={checkedItems.has(i)} onChange={() => checkHandler(i)} /><label htmlFor={"chk" + i}></label></div></td>
                    <td>{filteredUsers[i].devUserName}</td>
                    <td>{filteredUsers[i].devUserID}</td>
                    <td>{filteredUsers[i].getCompanyName}</td>
                    <td>{filteredUsers[i].companyTypeName || filteredUsers[i].deptName}</td>
                    {/* <td>{getSendOtpName(filteredUsers[i].sendOtpType)}</td> */}
                    {/* <td>{filteredUsers[i].lastLoginDateTime !== null ? dateFormat(new Date(filteredUsers[i].lastLoginDateTime)) : '미접속'}</td> */}
                    {/* <td>{pwdChgDate}</td> */}
                    <td>{filteredUsers[i].loginFailCnt ?? 0}회</td>
                    <td><button className="btn-admin-more" onClick={e => btnOnPopup(e, filteredUsers[i], i)}><i className="i-btn-more"></i></button></td>
                </tr>
            );
        }
        return list;
    }
    const list = renderUserList();
    const allCheckedHandler = (e) => {
        const isChecked = e.target.checked;
        setIsCheckedAll(isChecked);

        setCheckedItems(isChecked ? new Set(filteredUsers.map((_, i) => i)) : new Set());
    };

    const checkHandler = (index) => {
        setCheckedItems((prev) => {
            const newChecked = new Set(prev);
            newChecked.has(index) ? newChecked.delete(index) : newChecked.add(index);

            setIsCheckedAll(newChecked.size === filteredUsers.length);
            return newChecked;
        });
    };
    const setHeaders = () => {
        return [
            <div className="list-checkbox"><input type="checkbox" id="chkAll" checked={isCheckedAll} onChange={(e) => allCheckedHandler(e)} /><label htmlFor="chkAll"></label></div>,
            "이름",
            "이메일 아이디",
            "소속",
            "",
            // "2차인증",
            // "최종로그인일시",
            // "비밀번호변경일",
            "로그인실패",
            ""
        ];
    };
    const renderBatchWrap = () => {
        let batchWrapArr = [];
        batchWrapArr.push(
            <p key="batch" className="count"><span className="selected">{checkedItems.size}</span>/{filteredUsers.length} 선택됨</p>
        );
        return batchWrapArr;
    }

    const saveUserAuthGroupMember = (workingData) => {
        fetch('api/Manager/SaveUserAuthGroupMember', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(workingData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.table) {
                    showToast('success', '저장이 완료되었습니다.', 3000);
                    setGroupMemberList(data.table);
                    setIsCheckedAll(false);
                    setCheckedItems(new Set());
                    setPopupContent(null);
                }
            })
            .catch(error => console.error('Error saveUserAuthGroupMember:', error));
    };

    const getFilteredUserList = (isMatch = true) => {
        return userList.filter(user =>
            isMatch
                ? groupMemberList.some(group =>
                    group.groupSeq === selectedIndex && group.devUserID === user.devUserID
                )
                : !groupMemberList.some(group =>
                    group.groupSeq === selectedIndex && group.devUserID === user.devUserID
                )
        );
    };

    const openAddGroupMemberPopup = () => {
        const filteredUsers = getFilteredUserList(false);
        setPopupContent(
            <AddGroupMember
                onClose={setPopupContent}
                userList={filteredUsers}
                groupSeq={selectedIndex}
                saveUserAuthGroupMember={saveUserAuthGroupMember}
                loginUserId={loginUserId}
            />
        );
    };

    const removeGorupMember = () => {
        let workingData = [];
        checkedItems.forEach(item => {
            workingData.push({ workingTag: 'D', devUserId: loginUserId, groupSeq: selectedIndex, groupMemberId: filteredUsers[item].devUserID });
        });
        saveUserAuthGroupMember(workingData);
    }

    return (
        <div className="content-scroll">
            <div className="content" onMouseDown={handleMouseDown} >
                <div className="content-left">
                    <div className="list-top">
                        <h3 className='list-title'>사용자 권한 그룹</h3>
                        <button className='btn-add' onClick={() => setNewGroup('')}>
                            <i className='icoKdc24 add-24'></i>
                        </button>
                    </div>
                    <ul className='group-list'>
                        <li className={`group-item ${selectedIndex === -1 ? 'selected' : ''}`} key="-1" onClick={() => handleSelectGroup(-1)}>
                            <div className="group-name-wrap">
                                <i className="icoKdc20 user"></i>
                                <p className="group-name">전체</p>
                            </div>
                        </li>
                        {groupList.map((group, index) => (
                            <li className={`group-item ${selectedIndex === group.groupSeq ? 'selected' : ''}`} key={group.groupSeq} onClick={() => handleSelectGroup(group.groupSeq)}>
                                <div className="group-name-wrap">
                                    <i className='icoKdc20 user'></i>
                                    {editingIndex === index ? (
                                        <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus placeholder="그룹명을 입력하세요" />
                                    ) : (
                                        <p className='group-name'>{group.groupName}</p>
                                    )}
                                </div>
                                {editingIndex === index ? (
                                    <button className="btn-add" onClick={() => handleSaveEdit(index)}>확인</button>
                                ) : (
                                    <button onClick={() => setShowContextMenu(index)}>
                                        <i className='icoKdc24 kebab-24'></i>
                                        {showContextMenu === index && (
                                            <div className="context-menu">
                                                <ul>
                                                    <li onClick={() => handleEditGroup(index)}><a className='default'>그룹명 변경</a></li>
                                                    <li onClick={() => handleDeleteGroup(group.groupSeq)}><a className="nega">삭제</a></li>
                                                </ul>
                                            </div>
                                        )}
                                    </button>
                                )}
                            </li>
                        ))}
                        {newGroup !== null && (
                            <li className='group-item'>
                                <div className="group-name-wrap">
                                    <i className="icoKdc20 user"></i>
                                    <input type="text" value={newGroup} onChange={(e) => setNewGroup(e.target.value)} autoFocus placeholder="그룹명을 입력하세요" />
                                </div>
                                <button className="btn-cancel" onClick={() => setNewGroup(null)}>취소</button>
                                <button className="btn-add" onClick={handleAddGroup}>확인</button>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="content-right">
                    <h3 className='list-title mb-12'>{listTitle}</h3>
                    <div className="list-tools">
                        <div className={`btns-wrap ${selectedIndex === -1 ? "dis" : ""}`}>
                            {selectedIndex !== -1 &&
                                <button className='btn-appr' onClick={openAddGroupMemberPopup}>
                                    <i className='icoKdc12 add-12'></i>사용자 추가
                                </button>
                            }
                            {selectedIndex !== -1 &&
                                <button className='btn-rjct' onClick={removeGorupMember}>권한제외</button>
                            }
                            {checkedItems.size > 0 ? renderBatchWrap() : null}
                        </div>
                        <Filter key={0}
                            listData={veiwList}
                            setListView={setFilteredUsers}
                            multiKeywords={[{ name: "getCompanyName", title: "소속" }]}
                            searchKeyword={{ name: ["devUserID", "devUserName"], title: "이름 또는 아이디로 검색" }}
                        />
                    </div>
                    <Table className={"userlist"} headers={setHeaders()} list={list} />
                    <PopUp setContent={() => btnOnPopup()} content={popupContent} />
                </div>
            </div>
        </div>
    );
}

const AddGroupMember = (props) => {
    const [searchValue, setSearchValue] = useState('');
    const [matchedUsers, setMatchedUsers] = useState([]);
    const [userListState, setUserListState] = useState([]);
    const [workingData, setWorkingData] = useState([]);

    const splitKorean = (text) => text.normalize('NFD').replace(/[\u314e-\u314f\u1160-\u1161]/g, '');

    const handleKeyUp = () => {
        const trimmedValue = searchValue.trim();
        if (trimmedValue !== '') {
            const matched = props.userList.filter(user => {
                const devUserName = splitKorean(user.devUserName).toLowerCase();
                const searchText = splitKorean(trimmedValue).toLowerCase();
                return devUserName.includes(searchText);
            });
            setMatchedUsers(matched.slice(0, 5));
        } else {
            setMatchedUsers([]);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (matchedUsers.length === 1) {
                addUserToList(matchedUsers[0]);
            }
        }
    };

    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const addUserToList = (user) => {
        if (!userListState.some(u => u.devUserID === user.devUserID)) {
            setUserListState([...userListState, user]);
            setWorkingData(prev => [...prev, { workingTag: 'A', devUserId: props.loginUserId, groupSeq: props.groupSeq, groupMemberId: user.devUserID }]);
        }
        setSearchValue('');
        setMatchedUsers([]);
    };

    const removeUserFromList = (index) => {
        const userToRemove = userListState[index];
        setWorkingData(prev => prev.filter(item => item.groupMemberId !== userToRemove.devUserID));
        setUserListState(userListState.filter((_, i) => i !== index));
    };

    return (
        <div className="msg-popup center-box overflow-unset">
            <div className="modal">
                <div className="modal-top">
                    <h3 className="modal-title">그룹 멤버 추가</h3>
                    <button className="btn-close" onClick={() => props.onClose(null)}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                <div className="modal-cnts">
                    <form className="search-input" onKeyUp={handleKeyUp} onKeyDown={handleKeyDown}>
                        <i className="icoKdc20 add-g"></i>
                        <input
                            placeholder="사용자 이름을 입력하세요."
                            value={searchValue}
                            onChange={handleInputChange}
                        />
                    </form>
                    {matchedUsers.length > 0 && (
                        <div className="matched-users">
                            <ul className="user-list">
                                {matchedUsers.map((user, index) => (
                                    <li key={index} onClick={() => addUserToList(user)}>
                                        {`${user.devUserName} (${user.companyName || user.companyName}) <${user.devUserID}>`}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="mail-list-wrap">
                        <p className="mail-list-label">사용자</p>
                        <ul className="mail-list">
                            {userListState.map((user, index) => (
                                <li key={index}>
                                    <p className="user-name">{`${user.devUserName} (${user.companyName || user.companyName}) <${user.devUserID}>`}</p>
                                    <button className="btn-delete" onClick={() => removeUserFromList(index)}>
                                        <i className="icoKdc12 delete"></i>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="mail-list-btm">
                    <button className="btn-share" onClick={() => props.saveUserAuthGroupMember(workingData)}>
                        완료
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserAccountManagement;